import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * MatomoTracker
 *
 * The Matomo bootstrap script in <head> only fires trackPageView() once,
 * on initial HTML load. Because this app is a React SPA using react-router,
 * subsequent navigations do not trigger a new page load — so we need to
 * push a new page view to _paq whenever the location changes.
 *
 * This component renders nothing and has zero visual impact.
 * It respects the tracker installed via public/index.html; it does NOT
 * load its own tracker script.
 */
export const MatomoTracker = () => {
  const location = useLocation();
  const initialSent = useRef(true); // The head script already sent the first page view

  useEffect(() => {
    if (initialSent.current) {
      initialSent.current = false;
      return;
    }
    if (typeof window === "undefined" || !window._paq) return;
    const url = window.location.origin + location.pathname + location.search + location.hash;
    window._paq.push(["setReferrerUrl", document.referrer || ""]);
    window._paq.push(["setCustomUrl", url]);
    window._paq.push(["setDocumentTitle", document.title]);
    window._paq.push(["deleteCustomVariables", "page"]);
    window._paq.push(["trackPageView"]);
    window._paq.push(["enableLinkTracking"]);
  }, [location.pathname, location.search, location.hash]);

  return null;
};
